import syntaxTheme from '@docpocalypse/gatsby-theme/syntax-themes/github';

export default syntaxTheme;
